<template>
<div :class="$style.forgetMain">
    <v-icon @click="backMain" color="black" :class="$style.backLoginBtn">fas fa-arrow-alt-circle-left</v-icon>
    <h5 :class="$style.forgetMainTitle">
        <str index="forgetPw > label title" />
    </h5>
    <v-form 
        ref="userForm" 
        v-model="valid.form" 
        v-on:submit.prevent="sendResetPasswordCode"
        :class="$style.forgetMainForm"
        >
        <p :class="$style.forgetLabel">
            <str index="forgetPw > label email" />
        </p>
        <v-text-field 
            style="width: 75%;"
            @keyup="lowerCase('email' , email)" 
            outlined 
            v-model='email' 
            :disabled="startCount || valid.code"
            validate-on-blur 
            :rules="rules.validEmail"
            dense
            class="forgetInput"
            />
        <template v-if="!valid.code">
            <v-btn 
                @click="sendResetPasswordCode" 
                :class="[{[$style.resetCodeBtn]:$language()!='fr'}, {[$style.resetCodeBtnFr]:$language()=='fr'}]" 
                :disabled="!email || !validEmail(email) || sentResetPasswordCode"
                color="#1c94ec"
                :dark="!!email && validEmail(email) && !sentResetPasswordCode"
                v-if="!startCount"
                small>
                    <str :index="'button > send'"/>
            </v-btn>
            <v-btn v-else disabled :class="$style.resetCodeBtn" small>
                {{this.counting}}
            </v-btn>
            <button style="display: none;"></button>
        </template>


        <p :class="$style.forgetLabel">
            <str index="forgetPw > label code" />
        </p>
        
        <v-text-field style="width: 85%;" type='number' outlined v-model='code' dense class="forgetValidateInput" :disabled="valid.code">
            <v-icon slot="append-outer" :class="$style.validateIcon" color="success" v-if="valid.code != null && valid.code">fa-check-circle</v-icon>
            <v-icon slot="append-outer" :class="$style.validateIcon" color="error" v-if="valid.code != null && !valid.code">fa-times-circle</v-icon>
        </v-text-field>

        <transition name='fade'>
            <div v-if="valid.code">
                <v-form 
                    ref="userForgetPwForm" 
                    v-model="valid.userForgetPwForm" 
                    v-on:submit.prevent="validateUserForgetPwForm"
                >
                    <p :class="$style.forgetLabel">
                        <str index="forgetPw > label password" />
                    </p>
                    <v-text-field 
                         style="width: 75%;"
                        :class="['forgetPasswordInput',
                                $style.inputField]" 
                                :type="config.newPasswordType" outlined v-model='password' :rules="formRules().validPassword">
                        <template v-slot:message="{ message }">
                            <str :index="message" />
                        </template> 
                        <v-icon small slot="append" @click="togglePasswordType('newPasswordType')" 
                                    v-if="config.newPasswordType != 'password'">fa-eye</v-icon>
                        <v-icon small slot="append" @click="togglePasswordType('newPasswordType')" v-else>
                            fas fa-eye-slash
                        </v-icon>
                    </v-text-field>


                    <p :class="$style.forgetLabel">
                        <str index="forgetPw > label confirm_password" />
                    </p>          
                    <v-text-field 
                        style="width: 75%;"
                        :class="['forgetPasswordInput', 
                            $style.inputField]" 
                        :type="config.newPasswordConfirmType" 
                        outlined 
                        :rules="formRules(null, password).validConfirmPassword"
                        v-model='confirm.password'>
                        <template v-slot:message="{ message }">
                            <str :index="message" />
                        </template> 
                        <v-icon small slot="append" @click="togglePasswordType('newPasswordConfirmType')" 
                            v-if="config.newPasswordConfirmType != 'password'">fa-eye</v-icon>
                        <v-icon small slot="append" @click="togglePasswordType('newPasswordConfirmType')" v-else>
                            fas fa-eye-slash
                        </v-icon>
                    </v-text-field>

                    <button></button>
                        
                    <div style="text-align: center;">
                        <v-btn @click="validateUserForgetPwForm" color="#3f9ae6" dark :disabled="startChangingPw">
                            <str :index="'button > done'"/>
                        </v-btn>
                    </div> 
                  </v-form>
            </div>           
        </transition>
    </v-form>
    <messaging :display="message.display" :bottom="true" :text="message.text" :timeout="message.timeout" v-on:closed="message.display=false" :absolute="true"/>
</div>  
</template>

<script>
export default {
    name: 'ForgotPassword',
    data: function(){
        return {
            valid: {
                userForgetPwForm: false,
                code: null
            },
            email: null,
            code: null,
            password: null,
            confirm: {
                password: null
            },
            rules: {
                validEmail: [
                    v => !!v && this.validEmail(v) || this.message_invalid_email
                ],
                validPassword: [
                    v => !!v && v.length>=6 || this.message_invalid_password,
                    v => this.validate_password_strength(v) || this.message_weak_password
                ]
            },
            sentResetPasswordCode: false,
            startCount: false,
            counting: 60,
            message: {
                display: false,
                text: 'sample text',
                timeout: 6000
            },
            startChangingPw: false,
            config: {
                newPasswordType: "password",
                newPasswordConfirmType: "password",
                currentPasswordType: "password"
            },
        }
    },
    methods: {       
        reset: function() {
            this.sentResetPasswordCode = false;
            this.startCount = false;
            this.startChangingPw = false;
            this.email = null;
            this.code = null;
            this.password = null;
            this.confirm.password = null;
            this.counting = 60;
            this.valid.code = null;
            this.$refs.userForgetPwForm.reset();
            this.config = {
                newPasswordType: "password",
                newPasswordConfirmType: "password",
                currentPasswordType: "password"
            }
        },
        silence: function(){},
        sendResetPasswordCode: function(){
            var self = this;
            this.sentResetPasswordCode = true;
            this.$controller.security.user.sendResetPasswordCode(this.email).then( function(response){
                if (response.data.security.sendResetPasswordCode.result) {
                    self.startCounting();
                    self.message.text = self.labels('message > password resetEmail');
                    self.message.display = true;  
                } else {
                    if (!response.data.security.sendResetPasswordCode.foundUser) {
                        self.message.text = self.labels("message > user not found");
                        self.message.display = true;
                        self.sentResetPasswordCode = false;
                    } else {
                        self.message.text = "Error";
                        self.message.display = true;
                        self.sentResetPasswordCode = false;
                    }
                }         
            });
        },
        changePassword: function(){
            var self = this;
            this.$controller.security.user.changePassword(this.email,this.password).then( function(response){
                if (response.status == 200 && response.data.security.changePassword.result === true){
                    self.message.text = self.labels('message > password resetSuccess');
                    self.message.display = true; 
                    self.message.color = 'success';
                    self.reset();
                    self.backMain();
                }
            });            
        },
        validate_code: function(){
            if (this.code.length === 4){
                this.$controller.security.user.validateResetCode(this.email, this.code).then(function(response){
                    if (response.status == 200){
                        this.valid.code = response.data.security.validateResetCode.result;
                    }  
                }.bind(this));
            }
        },
        lowerCase: function(target , data){
            data = data.toLocaleLowerCase();
            eval("this."+target+" = '"+data+"'");
        },
        validEmail: function(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (email) {
                return re.test(email);  
            }
            return false;
        },
        validate_password_strength: function(password){
            var pass = password!=null ? isStrongPwd(password) : false;

            function isStrongPwd(password) {
            
                var uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            
                var lowercase = "abcdefghijklmnopqrstuvwxyz";
            
                var digits = "0123456789";
            
                var splChars ="!@#$%&*()-";
            
                var ucaseFlag = contains(password, uppercase);
            
                var lcaseFlag = contains(password, lowercase);
            
                var digitsFlag = contains(password, digits);
            
                var splCharsFlag = contains(password, splChars);

                var lengthFlag = password.length>=6;

                return (lengthFlag && ucaseFlag && lcaseFlag && digitsFlag && splCharsFlag)
            
            }
            
            function contains(password, allowedChars) {
            
                for (var i = 0; i < password.length; i++) {
            
                        var char = password.charAt(i);
            
                        if (allowedChars.indexOf(char) >= 0) { return true; }
            
                    }
            
                return false;
            }
            return pass
        },
        startCounting: function() {
            function counting (self, callback) {
                if (self.counting > 0) {
                    self.counting--;
                } else {
                    callback()
                }
            }

            function callbackCounting(self) {
                clearInterval(countInterval);
                self.counting = 60;
                self.startCount = false;
                self.sentResetPasswordCode = false;
            }

            this.startCount = true;
            var self = this;
            var countInterval = setInterval(function() {
                counting(self, function() {
                    callbackCounting(self) 
                });
            }, 1000);

        },
        backMain: function() {
            this.$emit("back");
        },
        validateUserForgetPwForm: function() {
            if (this.$refs.userForgetPwForm.validate()) {
                this.startChangingPw = true;
                this.customCLog("Changing Password >>>>>>>");
                this.changePassword();
            }
        },
        togglePasswordType: function(typePw){
            this.config[typePw] = this.config[typePw]=='password' ? 'text' : 'password';
        },           
    },
    computed: {
        confirmed_password: function(){
            var confirmed = (this.password!=null && this.password.length>0) ? this.password == this.confirm.password : true;
            return confirmed;
        },

        message_invalid_email: function(){
            return this.$store.getters.library.labels['messages > invalid email'][this.$language()];
        },

        message_invalid_password: function(){
            return this.$store.getters.library.labels['messages > invalid password'][this.$language()];
        },

        message_weak_password: function(){
            return this.$store.getters.library.labels['messages > weak password'][this.$language()];
        }
    },
    watch: {
        code: function(){
            this.validate_code();
        }
    }
}
</script>

<style module>
.forgetMain {
    padding-bottom: 15%;
    position: relative;
    max-height: 600px;
    overflow-y: auto;   
}
.forgetMain::-webkit-scrollbar {
    width: 0.8em;
}

.forgetMain::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 5px;
}

.forgetMain::-webkit-scrollbar-thumb {
    background-color: #d7d7d7;
    outline: 1px solid slategrey;
    border-radius: 5px;
}

    .forgetMainTitle {
        text-align: center;
        font-size: 20pt;
        font-weight: 400;
        color: #1c94ec;
        margin: 5% 10%;
        width: 80%;
    }

    .forgetMainForm {
        width: 60%;
        margin: 0 auto;
        position: relative;
    }

        .forgetLabel {
            margin-bottom: 0px !important;
            margin-left: 0.5%;
            color: black;
            font-size: 10pt;
        }

        .resetCodeBtn {
            position: absolute !important;
            top: 20px !important;
            right: -5px !important;
            text-transform: initial !important;
        }

        .resetCodeBtnFr {
            position: absolute !important;
            text-transform: initial !important;
            top: calc(30% - 1.2em) !important;
            right: calc(0% - 2em) !important;
        }

.validateIcon {
    margin-top: -12px;
}

.confirmed input{
    color: green !important;
}
.failed input{
    color: red !important;
}

.backLoginBtn {
    position: absolute;
    left: 4.5%;
    top: 5%;
}
@media only screen and (max-width: 398px) {
    .resetCodeBtnFr {
        top: 61px !important;
        right: -41px !important;
        }
  }
@media only screen and (max-width: 788px) and (min-width: 398px) {
   .resetCodeBtnFr {
        top: 41px !important;
        }
     .forgetLabel {
        width:80%;
        }
}
@media only screen and (max-width: 468px) {
    .resetCodeBtn {
        top: 41px !important;
        right: -25px !important;
        }
     .forgetLabel {
         width:100%;
     }
  }
</style>

<style lang="scss" scroped>
.forgetInput, .forgetPasswordInput {
    width: 80%;
    display: inline-block;
}

.forgetValidateInput {
    width: 90%;
    display: inline-block;
}

.forgetPasswordInput .v-input__control .v-input__slot, .forgetInput .v-input__control .v-input__slot {
    min-height: 0 !important;
}

.forgetPasswordInput .v-input__control .v-input__slot, .forgetValidateInput .v-input__control .v-input__slot {
    min-height: 0 !important;
}

.forgetPasswordInput .v-input__control .v-input__slot .v-input__append-inner {
    margin-top: 8px !important;
}
</style>